import { gql } from "@apollo/client"

// Returns an enumeration from postgres
export const GET_ENUMERATION = gql`
  query GetEnumeration($type: String!, $id: String!) {
    enumerations {
      getEnumeration(data: { type: $type, id: $id }) {
        enumeration {
          settings
        }
      }
    }
  }
`
